import { ErrorHandler, Injectable, Injector, inject } from "@angular/core";
import { Router } from "@angular/router";
import { IConfig } from "../interfaces";
import { ToasterService } from "./toaster.service";
import { BehaviorSubject } from "rxjs";
const LOGTAG = "[GlobalErrorHandlerService]";

@Injectable({
  providedIn: "root",
})
export class GlobalsService {
  readonly spinner: any;
  pageData: any;
  showsplash = true;
  loading = false;
  title = "overview";
  breadcrumb: string | undefined = undefined;
  config: IConfig = {
    url: new BehaviorSubject<string>(""),
  };
  widthClass: string = "lg:max-w-[82rem] md:max-w-7xl mx-auto";
  activeTextColor: string = "bg-clip-text bg-linear-to-tr from-green-400 to-green-900 text-transparent dark:to-green-900";

  readonly router: Router = inject(Router)
  private readonly toast: ToasterService = inject(ToasterService)

  constructor(
  ) {
  }

  async navigate(path: string, subpage = true) {
    await this.router.navigate([path], { replaceUrl: subpage });
  }

  async toastAlert(
    message: string,
    mode: "warning" | "danger" | "success"
  ) {
    switch (mode) {
      case "warning":
        this.toast.warn(message);
        break;
      case "danger":
        this.toast.error(message);
        break;
      case "success":
        this.toast.success(message);
        break;
      default:
        this.toast.success(message);
        break;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class GlobalErrorHandlerService implements ErrorHandler {
  // private toasterService = inject(ToasterService);
  constructor(private injector: Injector) {}

  public async handleError(error: unknown) {
    try {
      // const globalService: GlobalsService =
      //   this.injector.get<GlobalsService>(GlobalsService);
      // const message = this.getMessageFromUnknownError(error);
      // console.log(message);
      // await globalService.toastAlert(message, 'error');
    } catch (errorHandlerError) {
      console.error(`${LOGTAG} Internal exception:`, errorHandlerError);
    }
  }

  private getMessageFromUnknownError(error: unknown): string {
    let message = "An unknown error has occurred.";
    if (error instanceof Object && "rejection" in error) {
      error = (error as any).rejection;
    }
    if (error instanceof Error && error.message) {
      message = error.message;
    }
    return message;
  }
}
